import { render, staticRenderFns } from "./MdPatientContactsBox.vue?vue&type=template&id=42f82767&scoped=true&"
import script from "./MdPatientContactsBox.vue?vue&type=script&lang=js&"
export * from "./MdPatientContactsBox.vue?vue&type=script&lang=js&"
import style0 from "./MdPatientContactsBox.vue?vue&type=style&index=0&id=42f82767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f82767",
  null
  
)

export default component.exports